// Dummy Impact Drawer Implementation
(function () {
  // DRY: Save handler logic
  function removeOpenImpactDrawerParam() {
    try {
      const url = new URL(window.location.href);
      if (url.searchParams.has("chooseimpact")) {
        url.searchParams.delete("chooseimpact");
        window.history.replaceState({}, document.title, url.toString());
      }
    } catch (e) {}
  }

  if (!window.openImpactDrawer) {
    // Helper to close the impact drawer and overlay
    function closeImpactDrawer(drawer, overlay) {
      if (drawer) drawer.classList.remove("open");
      overlay.style.opacity = "0";
      document.body.style.overflow = "";
      setTimeout(() => (overlay.style.display = "none"), 300);
      removeOpenImpactDrawerParam();
      document.dispatchEvent(new CustomEvent('impactDrawerClosed'));
    }

    window.openImpactDrawer = function () {
      let wrapper = document.getElementById("impact-drawer-wrapper");
      let drawer = document.getElementById("impact-drawer");
      let overlay = document.getElementById("impact-drawer-overlay");
      if (!wrapper) {
        wrapper = document.createElement("div");
        wrapper.id = "impact-drawer-wrapper";
        wrapper.style.position = "relative";
        wrapper.style.zIndex = "9999";
        document.body.appendChild(wrapper);
      }
      if (!overlay) {
        overlay = document.createElement("div");
        overlay.id = "impact-drawer-overlay";
        overlay.className = "impact-drawer-overlay";
        wrapper.appendChild(overlay);
        overlay.onclick = function () {
          closeImpactDrawer(drawer, overlay);
        };
      }
      function getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(";").shift();
        return null;
      }
      function setCookie(name, value, days) {
        var expires = "";
        if (days) {
          var date = new Date();
          date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
          expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
      }
      function setCauseCookies(name, shortCode, defaultShortCode) {
        setCookie("user_cause_name", name, 30);
        setCookie("user_cause", shortCode, 30);
        setCookie('user_cause_wj', shortCode, 30);
        setCookie('user_cause_name_wj', name, 30);
        setCookie("default_cause", defaultShortCode, 30);
      }
      const user_cause = getCookie("user_cause");
      const default_cause = getCookie("default_cause");
      let highlightedCharity = user_cause || default_cause;

      // Save button reference (will be set later and updated after rendering)
      let saveBtn = null;
      let saveBtnHandler = null;

      // Helper: update Save button state
      function updateSaveBtnState() {
        // Always get the latest saveBtn from DOM
        saveBtn = document.querySelector("#impact-save-btn");
        if (!highlightedCharity || highlightedCharity === user_cause) {
          if (saveBtn) saveBtn.disabled = true;
        } else {
          if (saveBtn) saveBtn.disabled = false;
        }
      }

      function setupSaveBtnHandler(causeList, default_cause) {
        saveBtn = document.querySelector("#impact-save-btn");
        if (!saveBtn) return;
        // Remove all previous click handlers by cloning the node
        const newSaveBtn = saveBtn.cloneNode(true);
        saveBtn.parentNode.replaceChild(newSaveBtn, saveBtn);
        saveBtn = newSaveBtn;
        saveBtnHandler = function handleSave() {
          saveBtn = document.querySelector("#impact-save-btn");
          if (saveBtn.disabled) return;
          let selectedCharityObj = Array.isArray(causeList)
            ? causeList.find((c) => c.short_code === highlightedCharity)
            : null;
          const selectedCharityName = selectedCharityObj
            ? selectedCharityObj.name
            : highlightedCharity;
          setCauseCookies(selectedCharityName, highlightedCharity, default_cause);
          if (typeof window.computeCartPreview === "function") {
            const charityMessageCartBlock = document.getElementById("charity-message-cart-block");
            if(charityMessageCartBlock) {
              charityMessageCartBlock?.classList.add("loading");
              charityMessageCartBlock.innerHTML = "";
            }
            window.computeCartPreview();
          }
          if (typeof window.applyCause === "function") {
            window.applyCause(highlightedCharity);
          }
          removeOpenImpactDrawerParam();
          closeImpactDrawer(drawer, overlay);
        };
        saveBtn.addEventListener("click", saveBtnHandler);
      }
      if (!drawer) {
        drawer = document.createElement("div");
        drawer.id = "impact-drawer";
        drawer.className = "impact-drawer";
        const isLoggedIn = window?.IS_LOGGED_IN;
        // Add chooseimpact param to return_to
        let currentUrl = new URL(window.location.href);
        currentUrl.searchParams.set('chooseimpact', 'true');
        const returnTo = encodeURIComponent(currentUrl.pathname + currentUrl.search);
        const loginUrl = `/customer_authentication/login?return_to=${returnTo}`;
        drawer.innerHTML = `
            <div class="impact-drawer-header">
              <div class="impact-drawer-title">
                My impact
              </div>
              <button id="close-impact-drawer" class="impact-close" type="button" aria-label="Close impact drawer">
                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" style="display:block">
                  <line x1="1" y1="1" x2="9" y2="9" stroke="#222" stroke-width="0.8" stroke-linecap="round"/>
                  <line x1="9" y1="1" x2="1" y2="9" stroke="#222" stroke-width="0.8" stroke-linecap="round"/>
                </svg>
              </button>
            </div>
              ${!isLoggedIn ? `<div class="impact_not_logged_in_msg"><a class="ga4-signin-impact" href="${loginUrl}">Sign in</a> or <a class="ga4-create-account-impact" href="${loginUrl}">Create an account</a> to view your impact</div>` : ""}
            <div class="impact-desc">
              Select from the list below, and 20% of the proceeds from your next purchase will benefit them.
            </div>
            <div class="impact-selector">
              <div class="inner_wrapper"></div>
            </div>
            <div class="impact_cta_container">
              <button
                id="impact-save-btn"
                class="button button-primary save_button ga-my-impact-save"
                data-ga4="My Impact: Save and start shopping"
              >
                Save and start shopping
              </button>
              <button
                id="impact-skip-btn"
                class="button button-secondary skip_button ga-my-impact-skip"
                data-ga4="My Impact: Skip"
              >
                Skip
              </button>
            </div>
        `;
        wrapper.appendChild(drawer);
        document.getElementById("close-impact-drawer").onclick = function () {
          closeImpactDrawer(drawer, overlay);
        };
        // Set Save button disabled state based on highlightedCharity and user_cause
        saveBtn = drawer.querySelector("#impact-save-btn");
        const skipBtn = drawer.querySelector("#impact-skip-btn");
        updateSaveBtnState();
        setupSaveBtnHandler([], default_cause); // causeList will be set after rendering
        if (skipBtn) {
          skipBtn.addEventListener("click", function (e) {
            removeOpenImpactDrawerParam();
            closeImpactDrawer(drawer, overlay);
          });
        }
      }
      // Show the drawer and overlay
      overlay.style.display = "block";
      drawer.scrollTop = 0;
      setTimeout(() => (overlay.style.opacity = "1"), 10);
      setTimeout(() => {
        drawer.classList.add("open");
      }, 10);
      document.body.style.overflow = "hidden";

      // Always update Save button state and handler when opening the drawer
      setTimeout(() => {
        updateSaveBtnState();
        setupSaveBtnHandler(causeList, default_cause);
      }, 20);

      // --- Charity List Rendering ---
      // Example data, replace with real data as needed
      let causeList = [];
      if (
        window.causeMapObj &&
        typeof window.causeMapObj === "object" &&
        !Array.isArray(window.causeMapObj)
      ) {
        causeList = Object.values(window.causeMapObj);
      } else if (Array.isArray(window.causeMapObj)) {
        causeList = window.causeMapObj;
      }
      const impactSelector = drawer.querySelector(".inner_wrapper");
      impactSelector.innerHTML = "";

      // Helper: group by category
      function groupByCategory(list) {
        const grouped = {};
        list.forEach((item) => {
          if (!grouped[item.category]) grouped[item.category] = [];
          grouped[item.category].push(item);
        });
        return grouped;
      }

      // Helper: sort charities (simple sort by name)
      function charitySort(list) {
        return list.slice().sort((a, b) => a.name.localeCompare(b.name));
      }

      // Render charity list
      let selectedLi = null;
      if (Array.isArray(causeList) && causeList.length) {
        const sorted = charitySort(causeList);
        const grouped = groupByCategory(sorted);
        // Store references for dynamic update
        const charityNameDivsByCategory = {};
        Object.keys(grouped).forEach((category, idx) => {
          const section = document.createElement("section");
          section.setAttribute("data-sectionlevel", idx);
          // Category title
          const titleDiv = document.createElement("div");
          titleDiv.className = "pillar_title separator";
          const categoryDiv = document.createElement("div");
          categoryDiv.className = "category";
          categoryDiv.textContent = category;
          titleDiv.appendChild(categoryDiv);

          // Find highlighted charity in this category
          let highlightedCharityObj = null;
          if (Array.isArray(grouped[category])) {
            highlightedCharityObj = grouped[category].find(c => c.short_code === highlightedCharity);
          }
          const charityNameDiv = document.createElement("div");
          charityNameDiv.className = "charity_name";
          charityNameDiv.textContent = highlightedCharityObj ? highlightedCharityObj.name : "";
          titleDiv.appendChild(charityNameDiv);
          charityNameDivsByCategory[category] = charityNameDiv;

          section.appendChild(titleDiv);
          // Charity list
          const ul = document.createElement("ul");
          grouped[category].forEach((charity) => {
            if (!charity.charity_logo) return;
            const li = document.createElement("li");
            li.className = highlightedCharity === charity.short_code ? "selected_charity" : "";
            if (highlightedCharity === charity.short_code) {
              selectedLi = li;
            }
            const imgDiv = document.createElement("div");
            imgDiv.className = "charity_img";
            imgDiv.tabIndex = 0;
            imgDiv.setAttribute("role", "button");
            imgDiv.setAttribute("aria-pressed", highlightedCharity === charity.short_code);
            imgDiv.onclick = () => {
              // Remove selected class and update aria-pressed for all
              document.querySelectorAll(".inner_wrapper li").forEach((el) => {
                el.classList.remove("selected_charity");
                const btn = el.querySelector(".charity_img");
                if (btn) btn.setAttribute("aria-pressed", "false");
              });
              li.classList.add("selected_charity");
              imgDiv.setAttribute("aria-pressed", "true");
              highlightedCharity = charity.short_code;
              updateSaveBtnState();
              setupSaveBtnHandler(causeList, default_cause);
              // Update only the relevant category's charity name div
              Object.keys(charityNameDivsByCategory).forEach(cat => {
                let obj = grouped[cat].find(c => c.short_code === highlightedCharity);
                charityNameDivsByCategory[cat].textContent = obj ? obj.name : "";
              });
            };
            imgDiv.onkeydown = (e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                imgDiv.onclick();
              }
            };
            const img = document.createElement("img");
            img.src = charity.charity_logo;
            img.alt = charity.name;
            imgDiv.appendChild(img);
            li.appendChild(imgDiv);
            ul.appendChild(li);
          });
          section.appendChild(ul);
          impactSelector.appendChild(section);
        });
        // Scroll selected into view on load
        if (selectedLi) {
          setTimeout(
            () =>
              selectedLi.scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" }),
            0,
          );
        }
      } else {
        impactSelector.textContent = "No charities available.";
      }
    };
  }
  // Auto-open drawer if a specific URL param is set (e.g., ?chooseimpact=true)
  (function autoOpenDrawerByUrlParam() {
    try {
      const url = new URL(window.location.href);
      if (url.searchParams.get("chooseimpact") === "true") {
        setTimeout(() => window.openImpactDrawer(), 100);
      }
    } catch (e) {}
  })();
})();
